import { styled } from "../../../../styled-components";
import { css } from "styled-components";

const introProps = css`
    animation-name: intro;
    animation-duration: 0.4s;
    animation-iteration-count: 1;
`;

const outroProps = css`
    animation-name: outtro;
    animation-duration: 0.4s;
    animation-iteration-count: 1;
    transform: translateY(105%);
`;

const introTabletProps = css`
    animation-name: intro;
    animation-duration: 0s;
    animation-iteration-count: 1;
`;

const outroTabletProps = css`
    animation-name: outtro;
    animation-duration: 0s;
    animation-iteration-count: 1;
    transform: translateY(105%);
`;

interface Props {
    dismissed: boolean;
    introDone: boolean;
}
export const ContentRegion = styled.div<Props>`
    width: 100%;
    height: 100%;

    @keyframes intro {
        0% {
            transform: translateY(105%);
        }
        100% {
            transform: translateY(0);
        }
    }

    @keyframes outtro {
        0% {
            transform: translateY(0);
        }
        100% {
            transform: translateY(105%);
        }
    }

    & .modal-anim-tag {
        ${p => p.dismissed && outroProps}
        ${p =>
            !p.dismissed &&
            !p.introDone &&
            introProps}
        

        box-shadow: 0px -5px 17px rgba(50, 50, 50, 0.2), 0px -1px 2px rgba(0, 0, 0, 0.08);
        background-color: ${p => p.theme.baseColor};
    }

    /* Animation with time 0. We will probably want to add these for tablet sometime */
    & .modal-anim-tag-tablet {
        ${p => p.dismissed && outroTabletProps}
        ${p => !p.dismissed && !p.introDone && introTabletProps}
    }
`;

export const TabletContentRegion = styled(ContentRegion)<Props>`
    position: relative;
    width: 50%;
    min-width: 500px;
    height: 80%;

    border-radius: 12px;
    border: 1px solid ${p => p.theme.separatorColor};
    background-color: ${p => p.theme.baseColor};

    overflow: hidden;
`;

export const Wrapper = styled.div<{ tabletMode: boolean }>`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;

    ${p =>
        p.tabletMode &&
        css`
            background-color: rgba(0, 0, 0, 0.7);
        `}
`;
